/**
 * Utilidad para formateo de moneda dinámico por país
 * NO modifica datos - solo presentación visual
 */

// Configuración de formato por site/país
const CURRENCY_CONFIG = {
  MCO: { locale: 'es-CO', currency: 'COP', symbol: '$' },
  MLA: { locale: 'es-AR', currency: 'ARS', symbol: '$' },
  MLB: { locale: 'pt-BR', currency: 'BRL', symbol: 'R$' },
  MLM: { locale: 'es-MX', currency: 'MXN', symbol: '$' },
  MLC: { locale: 'es-CL', currency: 'CLP', symbol: '$' },
  MPE: { locale: 'es-PE', currency: 'PEN', symbol: 'S/' },
  MLV: { locale: 'es-VE', currency: 'VES', symbol: 'Bs.' },
  MEC: { locale: 'es-EC', currency: 'USD', symbol: '$' },
  MLU: { locale: 'es-UY', currency: 'UYU', symbol: '$' },
};

// Default (Colombia) si no se especifica site
const DEFAULT_CONFIG = CURRENCY_CONFIG.MCO;

/**
 * Obtiene la configuración de moneda para un site
 * @param {string} site - Código del site (MCO, MLA, etc.)
 */
export const getCurrencyConfig = (site) => {
  return CURRENCY_CONFIG[site] || DEFAULT_CONFIG;
};

/**
 * Formatea un número como moneda según el país
 * @param {number} value - Valor a formatear
 * @param {string} site - Código del site (MCO, MLA, etc.)
 * @param {object} options - Opciones adicionales
 */
export const formatCurrency = (value, site = 'MCO', options = {}) => {
  const config = getCurrencyConfig(site);
  const { showSymbol = true, decimals = 0 } = options;
  
  try {
    const formatted = new Intl.NumberFormat(config.locale, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(value || 0);
    
    return showSymbol ? `${config.symbol}${formatted}` : formatted;
  } catch (e) {
    // Fallback seguro
    return `$${(value || 0).toLocaleString()}`;
  }
};

/**
 * Formatea un número sin símbolo de moneda (solo separadores)
 * @param {number} value - Valor a formatear
 * @param {string} site - Código del site
 */
export const formatNumber = (value, site = 'MCO') => {
  const config = getCurrencyConfig(site);
  
  try {
    return new Intl.NumberFormat(config.locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value || 0);
  } catch (e) {
    return (value || 0).toLocaleString();
  }
};

/**
 * Formatea una fecha según el país
 * @param {string|Date} date - Fecha a formatear
 * @param {string} site - Código del site
 */
export const formatDate = (date, site = 'MCO') => {
  const config = getCurrencyConfig(site);
  
  try {
    return new Date(date).toLocaleDateString(config.locale);
  } catch (e) {
    return new Date(date).toLocaleDateString();
  }
};

export default {
  formatCurrency,
  formatNumber,
  formatDate,
  getCurrencyConfig,
};
